var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MobileLayout',[_c('Header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Home ")]},proxy:true}])}),_c('div',{staticClass:"content"},[_c('WidgetBalance'),_c('WidgetBrand',{attrs:{"items":_vm.brands}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }